import React from 'react';
import CSVReader from 'react-csv-reader';
import useAddUserFromCsv from '../../hooks/users/mutation/useAddUserFromCsv';
import { displaySuccess, history } from '../../utils';
import PageContainer from '../../components/Redesing/page-container';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import CardView from '../../components/Redesing/card-view';
import '../../css/newOrganizedCss/csv-reader.scss';
import useOrganization from '../../hooks/use-organization';
import useSystemList from '../../hooks/system/hook/useSystemList';
import { MovaticFieldGroupSelect } from '../../components/Redesing/movatic-field-group';
import { Option } from '../../ts/interface/components/table.interface';
import { MenuItem, SelectChangeEvent } from '@mui/material';
import CustomToast from '../../components/Redesing/custom-toast';
import { useUpdateEffect } from '../../hooks/use-update-effect';

const AddUsersFromCsv = () => {
  const organizationInfo = useOrganization();

  const { systemList } = useSystemList(organizationInfo.id);
  const [csvData, setCsvData] = React.useState<any[]>([]);
  const [selectedSystem, setSelectedSystem] = React.useState<Option>({
    label: '',
    value: '',
  });

  const addUserMutation = useAddUserFromCsv({
    onSuccess: () => {
      history.push('/users');
      displaySuccess('Users added successfully');
    },
  });

  useUpdateEffect(() => {
    // validate that if system is selected and csv data is present mutate the data
    if (!selectedSystem.value && csvData.length && Boolean(organizationInfo.id)) {
      CustomToast({
        type: 'error',
        message: 'Please select a system to add users',
      });
      return;
    }

    const validateSystem = Boolean(organizationInfo.id) ? selectedSystem.value : true;

    if (validateSystem && csvData.length) {
      handleFileUpload(csvData);
    }
  }, [selectedSystem, csvData]);

  const handleFileUpload = (data: any) => {
    addUserMutation.mutate({ data, system_id: selectedSystem.value });
  };

  return (
    <PageContainer isLoading={false} spaceName={'Add Users from CSV'}>
      <CardView
        title={'Supported Columns'}
        content={
          <Stack paddingX={2} paddingBottom={2}>
            <Typography>
              The following columns are supported in the CSV: firstName, lastName, phone,
              email, cardId
            </Typography>
            {Boolean(organizationInfo.id) && (
              <MovaticFieldGroupSelect
                label="Select system to create the user"
                value={selectedSystem?.value}
                onChange={(event: SelectChangeEvent) => {
                  const selectedOption = systemList.find(
                    (option) => option.value === event.target.value
                  );
                  setSelectedSystem(selectedOption || { label: '', value: '' });
                }}
                optionNodes={systemList?.map((option, index) => (
                  <MenuItem key={index} value={option.value}>
                    {option.label}
                  </MenuItem>
                ))}
              />
            )}
            <CSVReader
              cssClass="react-csv-input"
              label="The file must be a CSV formatted file."
              onFileLoaded={(data) => setCsvData(data)}
              parserOptions={{
                header: true,
                dynamicTyping: true,
                skipEmptyLines: true,
              }}
              accept=".csv, text/csv"
            />
          </Stack>
        }
      />
    </PageContainer>
  );
};

export default AddUsersFromCsv;
